module.exports = __webpack_public_path__ + "img/banner3_2_jp.02c7394d.png";